import type { ChartFormatters } from '@/shared/charts/renderers/echarts/time-series-chart/types/ChartFormatters.types';

import type { TooltipCard } from './TooltipCard.types';
import { renderTooltipCards } from './renderTooltipCards';

export function createTooltipContent() {
  let cards: TooltipCard[] = [];

  return {
    setCards: (nextCards: TooltipCard[]) => {
      cards = nextCards;
    },

    render: (formatters: ChartFormatters) => {
      return renderTooltipCards(cards, formatters);
    },
  };
}
